import _defineProperty from "D:/test/ieds-user-end/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import axios from "axios";
import { userStore } from "@/stores/modules/user";
import { ElMessage } from "element-plus";
import { login } from "@/utils/login";
const baseUrl = process.env.VUE_APP_BASEURL;
//未登录code
const UNPERMISSION = [401, 403];
const defaultConfig = {
  loading: ref(false),
  authorization: true,
  message: ""
};
const requestInterceptors = config => {
  const {
    customsOptions
  } = config;
  const userState = userStore();
  if (customsOptions?.authorization) {
    config.headers.token = userState.getToken;
  }
  return config;
};
export class Request {
  constructor(config) {
    _defineProperty(this, "instance", void 0);
    this.instance = axios.create(config);
    this.instance.interceptors.request.use(requestInterceptors);
    this.instance.interceptors.response.use(rep => {
      const {
        data
      } = rep;
      if (data.status == 200 || data.msg === "success" || data.msg === null || data.code == 0 || data.code == 200 || data.code == 500) {
        return Promise.resolve(data);
      } else {
        const returnLogin = () => {
          const user = userStore();
          user.loginOut();
          login();
        };
        if (UNPERMISSION.includes(data.code)) {
          ElMessage({
            type: "error",
            grouping: true,
            message: "请先登录"
          });
          returnLogin();
        }
        if (data.code >= 500 || data.status >= 500) {
          ElMessage.error(data.msg);
        }
        return Promise.reject(data);
      }
    });
  }
  request(method = "GET", url, data, config = {
    loading: ref(false),
    authorization: true
  }) {
    const options = Object.assign({}, defaultConfig, config);
    if (options.loading) {
      options.loading.value = true;
    }
    return new Promise((resolve, reject) => {
      this.instance({
        method,
        url,
        ...data,
        customsOptions: options
      }).then(res => {
        if (options.message) {
          ElMessage.success(options.message);
        }
        resolve(res);
      }).catch(e => {
        // reject(e);
        // resolve(e as unknown as Promise<T>);
        console.log(e);
      }).finally(() => {
        if (options.loading) {
          options.loading.value = false;
        }
      });
    });
  }
  get(url, data, config) {
    return this.request("GET", url, {
      params: data
    }, config);
  }
  post(url, data, config) {
    return this.request("POST", url, {
      data
    }, config);
  }
  delete(url, data, config) {
    return this.request("DELETE", url, {
      params: data
    }, config);
  }
  put(url, data, config) {
    return this.request("PUT", url, {
      data
    }, config);
  }
  download(url, config) {
    const axiosInstanse = axios.create();
    axiosInstanse.interceptors.request.use(requestInterceptors);
    return axiosInstanse.get(url, {
      responseType: "blob"
    });
  }
  downloadP(url, data, config) {
    const userState = userStore();
    const axiosInstanse = axios.create();
    axiosInstanse.interceptors.request.use(requestInterceptors);
    return axiosInstanse.post(url, data, {
      responseType: "blob",
      baseURL: baseUrl,
      headers: {
        token: userState.getToken
      }
    });
  }
  upload(file) {
    const axiosInstanse = axios.create();
    axiosInstanse.interceptors.request.use(requestInterceptors);
    const userState = userStore();
    const formData = new FormData();
    formData.append("file", file);
    return axiosInstanse.post(process.env.VUE_APP_UPLOAD, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        token: userState.getToken
      }
    });
  }
}
const request = new Request({
  timeout: 30000,
  baseURL: baseUrl
});
export default request;